import {isObservable, map, Observable, of, switchMap} from 'rxjs';

import {ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot} from '@angular/router';

import {isDeactivatable} from './deactivatable-component.types';

/**
 * This guard blocks the user from leaving the page without confirmation
 * @param blockMessage The message to show to the user when trying to leave the page (can be translation key)
 * The component must implement the IDeactivatable interface
 * @example
 * ```ts
 * @Injectable({
 * 	providedIn: 'root',
 * 		})
 * 			export class MyComponent implements IDeactivatable {
 * 				canDeactivate(): MaybeAsync<boolean> {
 * 					// your logic here
 * 						return true;
 * 				}
 * 			}
 * 				```
 */
export function ConfirmDeactivateGuard<T>(blockMessage = 'guards.confirm-deactivate.are-you-sure-leave'): CanDeactivateFn<T> {
	blockMessage = window.translate(blockMessage);
	return (component: T, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
		return checkCanDeactivate(component).pipe(
			switchMap(canDeactivateSelection => {
				if (!canDeactivateSelection) return of(false);
				if (isDeactivatable(component) && component.onDeactivate) {
					if (isObservable(component.onDeactivate)) {
						return component.onDeactivate(currentRoute, currentState, nextState, canDeactivateSelection).pipe(map(result => canDeactivateSelection && result));
					} else {
						return component.onDeactivate(currentRoute, currentState, nextState, canDeactivateSelection);
					}
				} else {
					return of(canDeactivateSelection);
				}
			}),
		);
	};
}

function checkCanDeactivate<T>(component: T): Observable<boolean> {
	return new Observable<boolean>(subscriber => {
		if (component && isDeactivatable(component)) {
			if (component.canDeactivate()) {
				subscriber.next(true);
			} else {
				// TODO
			}
		}

		// if (component && isDeactivatable(component)) {
		// 	debugger;
		// 	if (!component.canDeactivate()) {
		// 		subscriber.next(showConfirmDialog(blockMessage));
		// 	} else if (component.canDeactivate instanceof Promise || component.canDeactivate instanceof Observable) {
		// 		component.canDeactivate instanceof Observable
		// 			? firstValueFrom(component.canDeactivate).then(result => {
		// 					if (isSignal(result) && !result) {
		// 						subscriber.next(showConfirmDialog(blockMessage));
		// 					}
		// 				})
		// 			: component.canDeactivate.then(result => {
		// 					if (isSignal(result) && !result) {
		// 						subscriber.next(showConfirmDialog(blockMessage));
		// 					}
		// 				});
		// 	}
		// }
	});
}

// פונקציה להצגת דיאלוג אישור - מוסתרת כרגע
// function showConfirmDialog(blockMessage: string): boolean {
// 	return confirm(blockMessage);
// }
